import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIndustry, faPlus, faDisplay, faTrash } from '@fortawesome/free-solid-svg-icons';
import Header from '../../components/header/header';
import axiosInstance from '../../AxiosInstance';
import MyContext from '../../Context';
import styles from './scada.module.css';
import dashStyles from '../../styles/dashboard.module.css';
import Modal from '../../components/modal/modal';
import { TextInput } from '../../components/input/inputs';

export default function SCADAList() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { setCompanyChange } = useContext(MyContext);
    const project_id = parseInt(localStorage.getItem('project_id'));
    const [views, setViews] = useState([]);
    const [showCreate, setShowCreate] = useState(false);
    const [form, setForm] = useState({ name: '' });
    const [deleteId, setDeleteId] = useState(null);

    useEffect(() => {
        setCompanyChange(prev => prev + 1);
        load();
    }, [project_id]);

    const load = () => {
        if (!project_id) return;
        axiosInstance.get(`scada_view/?project_id=${project_id}`).then(res => {
            setViews(res.data.results || res.data);
        });
    };

    const create = () => {
        axiosInstance.post('scada_view/', { name: form.name, project: project_id }).then(res => {
            setShowCreate(false);
            setForm({ name: '' });
            navigate(`/scada/${res.data.id}`);
        });
    };

    const remove = (id) => {
        axiosInstance.delete(`scada_view/${id}/`).then(() => {
            setDeleteId(null);
            load();
        });
    };

    return (
        <div className={dashStyles.dashboard_container}>
            <Header />
            <div className={dashStyles.dashboardInnerContainer}>
                <div className={styles.listHeader}>
                    <div className={styles.listTitle}>
                        <FontAwesomeIcon icon={faIndustry} className="me-2" style={{ color: '#4F46E5' }} />
                        {t('scada.title')}
                    </div>
                    <button className={styles.primaryBtn} onClick={() => setShowCreate(true)}>
                        <FontAwesomeIcon icon={faPlus} />
                        {t('scada.newScreen')}
                    </button>
                </div>

                {views.length === 0 ? (
                    <div className={styles.emptyState}>
                        <FontAwesomeIcon icon={faDisplay} size="3x" />
                        <div style={{ fontSize: '15px' }}>{t('scada.noScreens')}</div>
                        <button className={styles.primaryBtn} onClick={() => setShowCreate(true)}>
                            <FontAwesomeIcon icon={faPlus} />
                            {t('scada.newScreen')}
                        </button>
                    </div>
                ) : (
                    <div className={styles.grid}>
                        {views.map(view => (
                            <div key={view.id} className={styles.card} onClick={() => navigate(`/scada/${view.id}`)}>
                                <div className={styles.cardPreview}>
                                    {view.background_image_url ? (
                                        <img src={view.background_image_url} alt={view.name} />
                                    ) : (
                                        <FontAwesomeIcon icon={faDisplay} size="2x" style={{ color: '#334155' }} />
                                    )}
                                </div>
                                <div className={styles.cardBody}>
                                    <div>
                                        <div className={styles.cardName}>{view.name}</div>
                                        <div className={styles.cardMeta}>
                                            {view.element_count} {view.element_count === 1 ? t('scada.element') : t('scada.elements')}
                                            {' · '}{view.canvas_width}×{view.canvas_height}
                                        </div>
                                    </div>
                                    <button
                                        className={styles.secondaryBtn}
                                        style={{ padding: '5px 8px', color: '#EF4444', borderColor: 'transparent' }}
                                        onClick={e => { e.stopPropagation(); setDeleteId(view.id); }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <Modal show={showCreate} setter={setShowCreate} name={t('scada.newScreen')} onClick={create} buttonName={t('common.save')}>
                <TextInput name="name" placeholder={t('scada.screenName')} form={form} setForm={setForm} />
            </Modal>

            <Modal
                show={!!deleteId}
                setter={() => setDeleteId(null)}
                name={t('scada.deleteScreen')}
                onClick={() => remove(deleteId)}
                buttonName={t('common.delete') || 'Delete'}
            >
                <div style={{ color: '#94A3B8', fontSize: '14px' }}>
                    {t('scada.deleteScreen')}?
                </div>
            </Modal>
        </div>
    );
}
